"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Map = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const rect_1 = require("@reach/rect");
const react_ui_1 = require("@yanzi/react-ui");
const Map_1 = __importDefault(require("ol/Map"));
const proj_1 = require("ol/proj");
const View_1 = __importDefault(require("ol/View"));
const react_1 = require("react");
const useMemoized_1 = require("../../hooks/useMemoized");
const MapContext_1 = require("../../MapContext");
const OLProvider_1 = require("../../openlayers/OLProvider");
const BlockingContentProvider_1 = require("../BlockingContentProvider");
const Map = ({ onResize = () => { }, fullscreen = false, children, zoomLevel, rotation, center, onZoom, onPan, onRotate, }) => {
    var _a;
    const mapDiv = react_1.useRef(null);
    const [view] = react_1.useState(() => new View_1.default({
        center: [0, 0],
        zoom: 1,
        projection: 'EPSG:3857',
    }));
    const [map] = react_1.useState(() => new Map_1.default({
        layers: [],
        controls: [],
    }));
    react_1.useEffect(() => {
        map.setView(view);
    }, [view, map]);
    const stableCenter = useMemoized_1.useMemoized(center);
    react_1.useLayoutEffect(() => {
        if (mapDiv.current) {
            map.setTarget(mapDiv.current);
        }
    }, [map]);
    react_1.useEffect(() => {
        if (rotation !== undefined) {
            view.setRotation(rotation);
        }
    }, [rotation, view]);
    react_1.useEffect(() => {
        if (zoomLevel) {
            view.setZoom(zoomLevel);
        }
    }, [zoomLevel, view]);
    react_1.useEffect(() => {
        map.updateSize();
    }, [map]);
    react_1.useEffect(() => {
        if (stableCenter) {
            try {
                view.fit([...proj_1.fromLonLat(stableCenter), ...proj_1.fromLonLat(stableCenter)], {
                    maxZoom: view.getZoom(),
                    duration: 100,
                });
            }
            catch (e) {
                console.error(e);
            }
        }
    }, [stableCenter, view]);
    react_1.useEffect(() => {
        if (onPan) {
            const listener = (e) => {
                onPan(proj_1.toLonLat(e.target.get(e.key)));
            };
            view.on('change:center', listener);
            return () => {
                view.un('change:center', listener);
            };
        }
        return () => { };
    }, [onPan, view]);
    react_1.useEffect(() => {
        if (onZoom) {
            const listener = () => {
                const zoom = view.getZoom();
                if (zoom !== undefined) {
                    onZoom(zoom);
                }
            };
            view.on('change:resolution', listener);
            return () => {
                view.un('change:resolution', listener);
            };
        }
        return () => { };
    }, [onZoom, view]);
    react_1.useEffect(() => {
        if (onRotate) {
            const listener = () => {
                onRotate(view.getRotation());
            };
            view.on('change:rotation', listener);
            return () => {
                view.un('change:rotation', listener);
            };
        }
        return () => { };
    }, [onRotate, view]);
    const mapDivRect = rect_1.useRect(mapDiv);
    const mapWidth = (_a = mapDivRect === null || mapDivRect === void 0 ? void 0 : mapDivRect.width) !== null && _a !== void 0 ? _a : 0;
    const lastWidth = react_1.useRef(-1);
    react_1.useEffect(() => {
        if (lastWidth.current !== mapWidth) {
            map.updateSize();
            onResize();
            lastWidth.current = mapWidth;
        }
    }, [map, mapWidth, onResize]);
    const [id] = react_1.useState(() => Math.random());
    react_1.useEffect(() => {
        map.set('id', id);
    }, [id, map]);
    const mapContextValue = react_1.useMemo(() => ({ map, fullscreen }), [fullscreen, map]);
    return (jsx_runtime_1.jsx(MapContext_1.MapContext.Provider, Object.assign({ value: mapContextValue }, { children: jsx_runtime_1.jsx(OLProvider_1.OLProvider, { children: jsx_runtime_1.jsx(BlockingContentProvider_1.BlockingContentProvider, { children: jsx_runtime_1.jsxs("div", Object.assign({ style: {
                        position: fullscreen ? 'fixed' : 'absolute',
                        top: 0,
                        left: 0,
                        right: 0,
                        bottom: 0,
                        zIndex: fullscreen ? 10000 : undefined,
                        flex: fullscreen ? undefined : 1,
                        overflow: fullscreen ? undefined : 'hidden',
                    } }, { children: [jsx_runtime_1.jsx("div", { style: {
                                backgroundColor: fullscreen ? '#fff' : 'transparent',
                                flex: 1,
                                position: 'absolute',
                                top: 0,
                                left: 0,
                                right: 0,
                                bottom: 0,
                            }, className: "mapdiv", ref: mapDiv }, void 0), children, jsx_runtime_1.jsx(react_ui_1.Global, { styles: { '.ol-overlaycontainer-stopevent': { display: 'none' } } }, void 0)] }), void 0) }, void 0) }, void 0) }), void 0));
};
exports.Map = Map;
//# sourceMappingURL=index.js.map